import React from 'react';
import styles from 'routes/vendorRe/pages/VendorComplete.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import P from 'routes/vendorRe/containers/commons/P';
import errorAccept from 'routes/vendorRe/images/errorAccept.png';
import { 
    commonBgColor, 
    contentCenter,
    commonErrorAcceptSize,
} from 'routes/vendorRe/constraint/constraints';

const VendorComplete = () => {
    return (
        <Container backgroundColor={commonBgColor} height="90vh" padding="0 40px">
            <VerticalFlex>
                <FlexChild flex="7">
                    <VerticalFlex>
                        <FlexChild justifyContent={contentCenter} gap="1em">
                            <img className={styles.img} src={errorAccept} alt='에러 접수 아이콘' />
                            <P size={commonErrorAcceptSize}>오류 접수가 완료되었습니다.</P>
                            <P size={commonErrorAcceptSize}>확인 후 빠르게 연락드리겠습니다.</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild flex="1">
                    <button className={styles.button} type='button'>홈으로 돌아가기</button>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorComplete;